import React, { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import dash from "../../images/dash.webp";
import { Link } from "react-router-dom";
import Collaborators from "../../components/shared/Collaborators";
import compliance from "../../images/compliance.png";

import Footer from "../../components/shared/Footer";

import OurService from "../../components/NewLandingPage/OurService";
import StepByStepCornerImg from "../../images/step-by-step-corner.png";
import business_plus from "../../images/business_plus.png";
import Header from "../../components/shared/Header";
import ExploreLeading from "../../components/NewLandingPage/ExploreLeading";
import "../../styles/LandingPage.scss";

import { useNavigate } from "react-router-dom";
import OurImpact from "../../components/NewLandingPage/OurImpact";
import { link } from "fs";
import Section1 from "../../components/NewLandingPage/Section1";
import Overlaycard from "../../components/NewLandingPage/Overlaycard";
import Plans from "../../components/NewLandingPage/Plans";
import StepByStep from "../../components/NewLandingPage/StepByStep";
import CreateMetaMask from "../../components/NewLandingPage/CreateMetaMask";
import ExchangeCCRT from "../../components/NewLandingPage/ExchangeCCRT";
import NetzenceEmbededSystem from "../../components/NewLandingPage/NetzenceEmbededSystem";
import GetStarted from "../../components/NewLandingPage/GetStarted";
import CloseCarbonPlatform from "../../components/NewLandingPage/CloseCarbonPlatform";
import SpotLight from "../../components/NewLandingPage/SpotLight";
import StayInformed from "../../components/NewLandingPage/StayInformed";
import Mission from "../../components/NewLandingPage/Mission";
import WebsiteFAQ from "../../components/NewLandingPage/WebsiteFAQ";

const HeroSection = () => {
  const heroRef = useRef(null);
  const marqueeRef = useRef(null);

  // Separate state for Business Plus (previously conflicted with businessType)

  // Reusable Counter Component

  // Plan data for the tabbed section (unchanged)
  const plans = [
    {
      name: "Governance",
      price: "0",
      tag: "Free",
      title: "CloseCarbon Governance",
      link: "/plans/governance",
      description: [
        "NDC Value (Nationally Determined Contributions)",
        "Government organization",
        "Private firms",
      ],
      features: [
        "Real-time tracking of NDC performance and sustainability targets ",
        "Independent validation of climate projects ",
        "Third-party verification of emissions data ",
        "Standard-aligned compliance framework ",
        "Issuance of CloseCarbon Reduction Tonnes (CCRTs) for verified reductions ",
        "Transparent oversight and reporting tools ",
      ],
    },
    {
      name: "Basic",
      price: "0",
      tag: "Free",

      title: "CloseCarbon Basic",
      link: "/plans/basic",

      description: [
        "Renewable Energy Projects ",
        "Infrastructure Transition & Monitoring Projects",
      ],
      features: [
        "Project validation aligned with recognized standards ",
        "Verification of carbon reduction data ",
        "Issuance of CloseCarbon Reduction Tonnes (CCRTs) ",
        "Real-time carbon monitoring dashboard",
        "Structured emissions reporting",
        "Clear, traceable proof of emissions reduction ",
      ],
    },
    {
      name: "Business",
      price: "15,995",
      tag: "Monthly",
      title: "CloseCarbon Business",
      link: "/plans/business",
      description: ["Gather Insights on Carbon emission data"],
      features: [
        "Real-time carbon emissions monitoring ",
        "Comprehensive carbon emissions reports",
        "Carbon Monitoring Certificate ",
        "Issuance of CloseCarbon Reduction Tonnes (CCRTs) ",
        "Optional review by Regional Oversight and Sub-CCVs (Non-Accredited Endorsing Bodies) for enhanced credibility ",
        "Verified documentation for sustainability reporting ",
      ],
    },
    {
      name: "Verifiers",
      tag: "Free",
      price: "0",
      title: "CloseCarbon Verifiers",
      link: "/plans/verifier",
      description: [
        "Whether you’re a beginner in your career or you’re already an established verifier, this plan offers a pivotal role in ensuring the accuracy and integrity of emission data.",
      ],
      features: [
        "Verification of project emissions and reductions ",
        "Structured data review tools ",
        "Compliance-based assessment framework ",
        "Standard-aligned verification workflow",
        "Reporting and approval documentation tools ",
      ],
    },
    {
      name: "Business Plus",
      link: "/plans/business-plus",
      price: "19,995",
      tag: "Monthly",
      title: "CloseCarbon BusinessPlus",
      description: [
        "Decentralized Peer-to-Peer Energy Trading ",
        "Blockchain-Based Smart Contracts",
      ],
      features: [
        "Real-time energy production and consumption tracking for decision-making ",
        "Secure marketplace for surplus renewable energy trading ",
        "Smart contract enabled transactions ",
        "Energy efficiency analytics and optimization tools ",
        "Carbon emissions reporting and certification ",
        "Issuance of CloseCarbon Reduction Tonnes (CCRTs) ",
        "Integrated monitoring of energy and carbon performance",
      ],
    },
  ];

  // const currentPlan = plans[activeTab];

  // Trigger fade animation when tab changes
  // useEffect(() => {
  //   setIsAnimating(true);
  //   const timer = setTimeout(() => setIsAnimating(false), 300);
  //   return () => clearTimeout(timer);
  // }, [activeTab]);

  // faq data

  const navigate = useNavigate();

  const CheckIcon = () => (
    <div className="w-5 h-5 rounded-full bg-[#E7F6EC] flex items-center justify-center flex-shrink-0">
      <svg
        width="12"
        height="9"
        viewBox="0 0 12 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 4.5L4.5 8L11 1"
          stroke="#099137"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );

  const FeatureList = ({ items, textColor = "text-[#645D5D]" }) => (
    <div className="flex flex-col gap-6">
      {items.map((item, idx) => (
        <div key={idx} className="flex items-center gap-4">
          {/* <CheckIcon /> */}
          <svg
            width="14"
            height="14"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.09375 0.0898438C2.78006 0.0898438 0.09375 2.77616 0.09375 6.08984C0.09375 9.40372 2.78006 12.0898 6.09375 12.0898C9.40763 12.0898 12.0938 9.40372 12.0938 6.08984C12.0938 2.77616 9.40763 0.0898438 6.09375 0.0898438ZM6.09375 11.3517C3.19894 11.3517 0.84375 8.98466 0.84375 6.08982C0.84375 3.19501 3.19894 0.83982 6.09375 0.83982C8.98856 0.83982 11.3438 3.19502 11.3438 6.08982C11.3438 8.98462 8.98856 11.3517 6.09375 11.3517ZM8.48831 3.89441L4.96799 7.43684L3.38268 5.85153C3.23624 5.70509 2.99886 5.70509 2.85224 5.85153C2.7058 5.99797 2.7058 6.23534 2.85224 6.38178L4.7083 8.23803C4.85474 8.38428 5.09211 8.38428 5.23874 8.23803C5.25561 8.22116 5.27006 8.20277 5.28319 8.18366L9.01894 4.42483C9.16519 4.27839 9.16519 4.04102 9.01894 3.89441C8.87231 3.74797 8.63494 3.74797 8.48831 3.89441Z"
              fill="#099137"
              stroke="#099137"
              stroke-width="0.18"
            />
          </svg>

          <span
            className={`font-medium text-[18px] leading-[21px]  ${textColor}`}
          >
            {item}
          </span>
        </div>
      ))}
    </div>
  );

  const ServiceIcon = ({
    icon: Icon,
    bgColor = "bg-[#E7F6EC]",
    iconColor = "text-[#0D924F]",
  }) => (
    <div
      className={`w-12 h-12 rounded-lg ${bgColor} flex items-center justify-center`}
    >
      <Icon className={`w-9 h-9 ${iconColor}`} />
    </div>
  );

  // ----- Service data (unchanged) -----

  useEffect(() => {
    // Simple entrance animation
    const ctx = gsap.context(() => {
      gsap.from(".hero-text", {
        y: 50,
        opacity: 0,
        duration: 1,
        stagger: 0.2,
        ease: "power3.out",
      });

      gsap.from(".image", {
        x: 100,
        opacity: 0,
        duration: 0.2,
        delay: 1,
        stagger: 0.2,
        ease: "back.out(1.7)",
      });

      gsap.from(".hero-image-container", {
        x: 100,
        opacity: 0,
        duration: 1.2,
        delay: 0.2,
        ease: "in",
      });

      // Marquee infinite scroll setup (if needed via JS, but CSS is simpler for infinite loop)
    }, heroRef);

    return () => ctx.revert();
  }, []);

  const marqueeItems = [
    "Carbon Tracking",
    "Carbon Monitoring",
    "Carbon Offset Initiatives",
    "Sustainability",
    "Renewable Energy Solutions",
    "Educational Resources",
    // "Carbon Credits Program", "Environmental Impacts Reports",
    // "Government and Regulatory Guidance"
  ];

  // Duplicate list for seamless scrolling
  const seamlessMarquee = [...marqueeItems, ...marqueeItems, ...marqueeItems];

  // ----- Step-by-Step data for stack scroll effect -----

  return (
    <>
      <Header />
      <Section1 />
      <div
        ref={heroRef}
        className="relative w-full  bg-white overflow-hidden font-sans"
      >
        {/* Main Content Container */}

        {/* Scrolling Marquee (Frame 112) */}
        <div className=" md:top-[800px] left-0 w-full overflow-hidden flex items-center bg-white/50 backdrop-blur-sm border-t border-gray-100">
          <div
            className="flex gap-[36px] animate-marquee whitespace-nowrap"
            ref={marqueeRef}
          >
            {seamlessMarquee.map((text, index) => (
              <div
                key={index}
                className="flex justify-center items-center px-[18px] py-[12px] h-[80px] border border-[#0D924F] rounded-xl bg-white/80 min-w-max "
              >
                <span className="font-medium text-[18px] text-[#141414]">
                  {text}
                </span>
              </div>
            ))}
          </div>
        </div>

        <style>{`
          @keyframes marquee {
              0% { transform: translateX(0); }
              100% { transform: translateX(-50%); }
          }
          .animate-marquee {
              animation: marquee 60s linear infinite;
          }
          .animate-marquee:hover {
              animation-play-state: paused;
          }
          /* Custom bounce animation for the floating card */
          .animate-bounce-slow {
              animation: bounce-slow 3s infinite;
          }
          @keyframes bounce-slow {
              0%, 100% { transform: translateY(0); }
              50% { transform: translateY(-10px); }
          }
        `}</style>
      </div>

      {/* section 2 */}
      <section className="relative w-full min-h-[600px] bg-[#FAFAFA] text-[#3B3B3B] font-sans overflow-hidden py-16 md:py-20 z-0">
        {/* Background Decor (Ellipses) - Simplified representation of 'Group 14' */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          <div className="absolute top-[-27px] left-[549px] w-[968px] h-[1024px] opacity-30 hidden lg:block">
            <div className="absolute w-[544px] h-[544px] left-[265px] top-[74px] rounded-full border border-gray-300/60"></div>
            <div className="absolute w-[385px] h-[385px] left-[0px] top-[574px] rounded-full border border-gray-300/60"></div>
            <div className="absolute w-[544px] h-[544px] left-[410px] top-[265px] rounded-full border border-gray-300/60"></div>
            {/* Random dots to match style */}
            <div className="absolute w-[14px] h-[14px] left-[700px] top-[128px] bg-gray-300 rounded-full opacity-50"></div>
            <div className="absolute w-[16px] h-[16px] left-[100px] top-[680px] bg-gray-300 rounded-full opacity-50"></div>
            <div className="absolute w-[16px] h-[16px] left-[400px] top-[400px] bg-gray-300 rounded-full opacity-50"></div>
          </div>
        </div>

        <div className="relative max-w-[1440px] mx-auto px-4 sm:px-6 md:px-10 lg:px-16 xl:px-[120px] flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          {/* Left Content (Text) */}
          <div className="flex flex-col items-start gap-8 max-w-[503px] lg:shrink-0 z-0 w-full">
            <div className="flex flex-col gap-4">
              <span className="font-medium text-[22px] sm:text-[28px] md:text-[36px] leading-[1.2] md:leading-[43px] text-[#3B3B3B]">
                Our Platform
              </span>
              <h2 className="font-bold text-[34px] sm:text-[44px] md:text-[56px] lg:text-[64px] leading-[1.2] lg:leading-[76px] text-[#3B3B3B] break-words">
                CloseCarbon
              </h2>
              <p className="font-normal text-[16px] md:text-[18px] leading-[1.5] md:leading-[27px] text-[#3E3838]">
                CloseCarbon is an end-to-end digital platform that enables
                real-time emissions monitoring, transparent verification, and
                blockchain-backed incentives empowering individuals and
                organizations to turn climate action into measurable impact.
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-5 w-full">
              <div className="w-full bg-[#E3E3E3] text-[14px] rounded-full text-center py-[6px] px-[12px] whitespace-nowrap">
                Measure
              </div>
              <div className="w-full bg-[#E3E3E3] text-[14px] rounded-full text-center py-[6px] px-[12px] whitespace-nowrap">
                Verify
              </div>
              <div className="w-full bg-[#E3E3E3] text-[14px] rounded-full text-center py-[6px] px-[12px] whitespace-nowrap">
                Reduce
              </div>
              <div className="w-full bg-[#E3E3E3] text-[14px] rounded-full text-center py-[6px] px-[12px] whitespace-nowrap">
                Incentive
              </div>
            </div>

            <button
              type="button"
              onClick={() =>
                document
                  .getElementById("plans")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
              className="hero-btn group flex justify-center items-center border-2 border-[#E4E7EC] py-[6px] gap-[10px] w-[193px] max-w-full h-[56px] bg-[#0D924F] rounded-xl hover:bg-[#0d713f] cursor-pointer"
            >
              <span className="font-medium text-[24px] text-white text-center">
                Get Started
              </span>
            </button>
          </div>

          {/* Right Content (Dashboard Mockup) - "Existing user" */}
          <div className="animate-float relative w-full max-w-[800px] min-w-0 lg:flex-1 flex items-center justify-center origin-center mx-auto">
            <img
              src={dash}
              alt=""
              className="w-full h-auto max-w-full object-contain"
            />
          </div>
        </div>
      </section>

      {/* section 3 */}
      <OurImpact />

      {/* section 4 (services) - unchanged */}

      <OurService />
      {/* section 5 (tabbed plans) - unchanged */}
      <Plans />

      <Collaborators />

      {/* ----- Step-by-Step Guide with Stack Scroll Effect ----- */}
      <StepByStep />

      {/* section 6 placeholder */}
      <CreateMetaMask />

      {/* section 7 */}

      <ExchangeCCRT />

      {/* section 8 */}
      <NetzenceEmbededSystem />
      {/* section 9 */}
      <GetStarted />
      {/* section 10 */}
      <CloseCarbonPlatform />

      {/* section 11 */}
      <SpotLight />
      {/* section 13 */}
      <StayInformed />

      {/* section 12 */}

      <ExploreLeading />

      {/* section 13 */}
      <Mission />

      {/* section 14 */}
      <WebsiteFAQ />
      <Overlaycard />
      <Footer />
    </>
  );
};

export default HeroSection;
